export const mapControlWidth = '46px';
export const mapControlBg = 'rgba(255,255,255, .9)';
